<template>
  <div>

    <div v-if="group.type === 'satellite_grouping_player'">
      <right-satellite-sublayer
        ref="satellite"
        :group="group"
        :locations="locations"
        :satellites="satellites"
        :initialOpacity="100"
        :timeFeatures="satelliteTimeFeatures"
        @changeInputMenu="changeInputMenu($event)"
        @changeCurrentSatelliteState="changeCurrentSatelliteState($event)"></right-satellite-sublayer>
    </div>

    <div v-else>
      <div
        v-show="enabledGroupLayer"
        :class="`sub-layers group-layers-${group.name}`"
        v-for="(item, i) in group.layers"
        :key="i"
      >
        <right-sub-layer-map-menu
          v-if="
            /*  !item.values_.hide_on_menu && */
            item.values_.visible &&
            (item.values_.caption_html ||
              item.values_.url_caption ||
              item.values_.timeFeatures)
          "
          :layer="item"
          :group="group"
          :showMenuLayer="showMenuLayer"
          :showMenuLayerPesticides="showMenuLayerPesticides"
          :showMenuLayerDiffuseLoads="showMenuLayerDiffuseLoads"
          @changeInputMenu="changeInputMenu($event)"
        />
      </div>
    </div>

  </div>
</template>

<script>
import RightSubLayerMapMenu from "@/components/common/NewMapMenu/RightSubLayerMapMenu";
import RightSatelliteSublayer from "@/components/common/NewMapMenu/SatelliteSublayer/RightSatelliteSublayer";

export default {
  name: "RightGroupLayerMapMenu",
  props: ["group", "visible", "locations", "satellites"],
  components: {
    RightSatelliteSublayer,
    RightSubLayerMapMenu,
  },
  data: () => ({
    enabledGroupLayer: undefined,
    satelliteTimeFeatures: undefined,
  }),
  created() {
    this.enabledGroupLayer = true;
  },
  watch: {
    visible(val) {
      if (typeof this.$refs.satellite != 'undefined' && typeof this.$refs.satellite.enabledSublayer != 'undefined') {
        this.$refs.satellite.enabledSublayer = val;
      }
    }
  },
  computed: {
    showTitleOfGroupLayer() {
      return (
        this.group &&
        this.group.type !== "overlayers" &&
        this.group.type !== "satellite_grouping_player"
      );
    },

    showMenuLayerDiffuseLoads() {
      let layerVisible = false;
      this.group.layers.find((layer) => {
        if (
          (layer.values_.id === 503 && layer.values_.visible == true) ||
          (layer.values_.id === 504 && layer.values_.visible == true) ||
          (layer.values_.id === 505 && layer.values_.visible == true)
        ) {
          layerVisible = true;
          return;
        }
      });
      return layerVisible;
    },

    showMenuLayerPesticides() {
      let layerVisible = false;
      this.group.layers.find((layer) => {
        if (
          (layer.values_.id === 500 && layer.values_.visible == true) ||
          (layer.values_.id === 501 && layer.values_.visible == true) ||
          (layer.values_.id === 502 && layer.values_.visible == true)
        ) {
          layerVisible = true;
          return;
        }
      });
      return layerVisible;
    },

    showMenuLayer() {
      let layerVisible = false;
      this.group.layers.find((layer) => {
        if (
          (layer.values_.id === 735 && layer.values_.visible == true) ||
          (layer.values_.id === 736 && layer.values_.visible == true) ||
          (layer.values_.id === 737 && layer.values_.visible == true)
        ) {
          layerVisible = true;
          return;
        }
      });
      return layerVisible;
    },
  },
  methods: {
    changeEnabledGroupLayer(visible) {
      this.$emit("changeEnabledGroupLayer", { visible, name: this.group.name });
    },
    changeInputMenu(event) {
      this.$emit(event.eventName, event.params);
    },
    changeCurrentSatelliteState(state) {
      const lastVisibleLayer = this.group.layers.find(
        (layer) => layer.values_.visible === true
      );
      const currentVisibleLayer = this.group.layers.find(
        (layer) => {
          return (layer.values_.name === `${state.location} - ${state.satellite}`);
        }
      );
      const currentVisibleLayerId = currentVisibleLayer?.values_.id;
      const lastVisibleLayerId = lastVisibleLayer?.values_.id;
      let bbox = undefined;
      if (currentVisibleLayerId !== lastVisibleLayerId) {
        bbox = currentVisibleLayer?.values_.url_params.BBOX;
      }
      this.satelliteTimeFeatures = currentVisibleLayer?.values_.timeFeatures;
      this.$emit("changeCurrentSatelliteState", {
        lastVisibleLayerId,
        currentVisibleLayerId,
        bbox,
        ...state,
      });
    },

  },
};
</script>
<style scoped>
.group-layer-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  margin: 24px 0px;
}

.layer-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
</style>
